import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@material-ui/core'
import Link from './Link'

export default class LinkButton extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  }

  render() {
    const { children, ...props } = this.props
    return (
      <Button component={Link} color="primary" {...props}>
        {children}
      </Button>
    )
  }
}
